const SAMPLE_VIS_MAX_QUERY_SIZE = 10000;

export default SAMPLE_VIS_MAX_QUERY_SIZE;
